"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicroviewCommunicationChannel = void 0;
var MicroviewCommunicationService = /** @class */ (function () {
    function MicroviewCommunicationService() {
        this.topicMap = {};
        var windowWithTopicMap = window;
        if (!windowWithTopicMap.microViewTopicMap) {
            windowWithTopicMap.microViewTopicMap = this.topicMap;
        }
        else {
            this.topicMap = windowWithTopicMap.microViewTopicMap;
        }
    }
    MicroviewCommunicationService.prototype.send = function (topic, data) {
        if (!this.topicMap[topic]) {
            throw new Error('ERROR: ' + topic + ' does not exist.');
        }
        return this.topicMap[topic](data);
    };
    MicroviewCommunicationService.prototype.listen = function (topic, handler) {
        var _this = this;
        if (this.topicMap[topic]) {
            throw new Error('ERROR: Already listening to ' + topic);
        }
        this.topicMap[topic] = handler;
        return function () {
            delete _this.topicMap[topic];
        };
    };
    MicroviewCommunicationService.instance = new MicroviewCommunicationService();
    return MicroviewCommunicationService;
}());
var MicroviewCommunicationChannel = /** @class */ (function () {
    function MicroviewCommunicationChannel() {
    }
    MicroviewCommunicationChannel.prototype.getFullName = function () {
        return this.namespace + '.' + this.name;
    };
    // This function returns the function to unsubscribe. Please remember to unsubscribe.
    MicroviewCommunicationChannel.prototype.listen = function (handler) {
        return MicroviewCommunicationService.instance.listen(this.getFullName(), handler);
    };
    MicroviewCommunicationChannel.prototype.call = function (r) {
        return MicroviewCommunicationService.instance.send(this.getFullName(), r);
    };
    return MicroviewCommunicationChannel;
}());
exports.MicroviewCommunicationChannel = MicroviewCommunicationChannel;
//# sourceMappingURL=MicroviewCommunicationChannel.js.map